/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { HiOutlineMenuAlt2 } from 'react-icons/hi';
import { IoPricetagOutline } from 'react-icons/io5';
import StarIcon from '@mui/icons-material/Star';
import { HiOutlineBuildingOffice } from 'react-icons/hi2';
import { CiSquarePlus, CiSearch, CiEdit } from 'react-icons/ci';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoIosArrowRoundBack } from 'react-icons/io';
import Tooltip from '@mui/material/Tooltip';
import Call from '../../components/images/Call.png';
import IconButton from '@mui/material/IconButton';
import Email from '../../components/images/email.png';
import Tag from '../../components/images/tag.png';
import Chat from '../../components/images/chat.png';
import Note from '../../components/images/note.png';
import Grid from '@mui/material/Grid';
import './contactverifier.css';
import parse from 'html-react-parser';
import { LuContact } from 'react-icons/lu';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import axios from 'axios';
import { TbWorld, TbAddressBook, TbMapPinCode, TbBrandLinkedin, TbBriefcase } from 'react-icons/tb';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InfiniteScroll from 'react-infinite-scroll-component';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import Key from '../../clientVariables.json';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import moment from 'moment';
import ToastMessage from '../../components/ToastMessage';
import Search from '../Searchcontact';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tabs from '@mui/material/Tabs';
import ContactActivity from './ContactActivity';
import UpdateCompanyContact from './UpdateCompanyContact';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useSelector } from 'react-redux';
import { companiesManagementSelector } from './redux/selector';
import AddCompanyContact from './AddCompanyContact';
import CompanyJobs from './CompanyJobs';
import CompanyJobDetail from './CompanyJobDetail';
import Contacts from './Contacts';
import { CheckCircleOutline, StarBorder } from '@mui/icons-material';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function Companyinfo(props) {
  const [value, setValue] = React.useState(0);

  const scrollRef = useRef(null);

  const { searchInput, searchType } = useSelector(companiesManagementSelector);

  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyDetails, setCompanyDetails] = useState([]);
  const [showContacts, setShowContacts] = useState(true);
  const [companyContacts, setCompanyContacts] = useState([]);
  const [companyJobs, setCompanyJobs] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [favHasMore, setFavHasMore] = useState(true);

  const [offset, setOffset] = useState(0);
  const [favoffset, setFavOffset] = useState(0);

  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [showAddContactPopup, setShowAddContactPopup] = useState(false);
  // const [contactName, setContactName] = useState('');
  // const [contactRole, setContactRole] = useState('');
  // const [contactEmail, setContactEmail] = useState('');
  // const [contactPhone, setContactPhone] = useState('');
  // const [contactLinkedin, setContactLinkedin] = useState('');
  const [contactDetails, setContactDetails] = useState({});
  const [jobDetails, setJobDetails] = useState({});
  const [selectedcontact, setselectedcontact] = useState(null);
  const [jobshasmore, setjobshasmore] = useState(true);
  const [contactshasmore, setcontactshasmore] = useState(true);

  const [joboffset, setjoboffset] = useState(0);
  const [contactsoffset, setcontactsoffset] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorE2, setAnchorE2] = React.useState(null);
  const [recruiterview, setrecruiterview] = useState(false);
  const [verified, setVerified] = useState(false);
  const [verifiedPhone, setVerifiedPhone] = useState(false);
  const [selectedJobId, setselectedJobId] = useState('');
  const [sendMail, setSendMail] = useState(false);
  const [showContactMail, setShowContactMail] = useState(false);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [contactActivityView, setContactActivityView] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [showEditContact, setShowEditContact] = useState(false);
  const [searchContactsResult, setSearchContactResult] = useState();
  const [searchInputValue, setSearchInputValue] = useState('');
  const [companyLoader, setCompanyLoader] = useState(false);
  const [jobDetailsLoader, setJobDetailsLoader] = useState(false);
  const [searchCompanyInputValue, setSearchCompanyInputValue] = useState('');
  const [contactMailData, setContactMailData] = useState([]);
  const [showMailForm, setShowMailForm] = useState(false);
  const [showContactMessage, setShowContactMessage] = useState(false);
  const [contactMailMessage, setContactMailMessage] = useState('');
  const [contactMailSubject, setContactMailSubject] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [favoriteCompanies, setFavoriteCompanies] = useState([]);
  const [totalJobsCount,setTotalJobsCount] = useState(0)
  const addToFavorites = (companyId) => {
    fetch(`${Key.domain}/company/addToFav`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        favourite: 1,
        user_id: sessionStorage.getItem('id'),
        companyId: companyId,
      }),
    }).then((response) => {
      response.json().then((resdata) => {
        getFavCompanies(resdata?.data?.insertId ? resdata.data.insertId : resdata.data[0].id);
      });
    });
  };

  const getFavCompanies = (favid) => {
    fetch(`${Key.domain}/company/getFavourites`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        page: 0,
        limit: limit,
        uid: sessionStorage.getItem('id'),
        favid: favid ? favid : 0

      }),
    }).then(async (response) => {
      response.json().then(async (resdata) => {
        if (resdata.data.length === 0) {
          setFavHasMore(false);
          setCompanyLoader(true);
        } else {
          setFavoriteCompanies(resdata.data);
          // setFavOffset(favoffset + resdata.data.length);

        }
      });
    });
  };

  const removeFromFavorites = (companyId) => {
    fetch(`${Key.domain}/company/removeFavourites`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        companyId: companyId,
        uid:sessionStorage.getItem("id")
      }),
    }).then((response) => {
      response.json().then(async (resdata) => {
        await getFavCompanies();

      });
    });
  };

  const isFavorite = (companyId) => {
    return favoriteCompanies.some((company) => company.companyid === companyId);
  };

  const textStyle1 = {
    fontSize: '12px',
    marginLeft: '3px',
    cursor: 'pointer',
    // textDecoration: 'underline',
    color: verified ? 'green' : 'inherit', // Change color to green if verified
  };
  const textStyle = {
    fontSize: '12px',
    marginLeft: '3px',
    cursor: 'pointer',
    // textDecoration: 'underline',
    color: verified ? 'green' : 'inherit', // Change color to green if verified
  };

  const HandleRecuiterview = (type) => {
    if (type === 'contacts') {
      setrecruiterview(true);
    } else {
      setrecruiterview(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorE2);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClose2 = () => {
    setAnchorE2(null);
  };
  // Effect to update favorite companies when companies list changes

  useEffect(() => {
    getFavCompanies()

  }, [])

  useEffect(() => {
    if (searchType !== 'contact') {
      searchCompany();
    }
  }, [searchInput]);

  useEffect(() => {
    if (jobDetails?.companyid === companyDetails?.id) {
      getCOmpanyContacts(jobDetails?.companyid, 0, false);
    }
  }, [jobDetails]);

  useEffect(() => {
    setrecruiterview(searchType === 'contact');
  }, [searchType]);

  const handleclicknotes = (item) => {
    // console.log(item);
    if (item === 'email') {
      setShowContactMail(true);
      setContactActivityView(item);
    } else {
      setShowContactMail(false);
      setSendMail(false);
      setContactActivityView(item);
    }
  };
  const limit = 10;

  const fetchMoreData = () => {
    fetch(`${Key.domain}/company/get_Companies_List`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        page: offset,
        limit: limit,
        searchBy: searchType,
        title: searchInput,
        user_type_id: sessionStorage.getItem('usertype'),
      }),
    }).then(async (response) => {
      response.json().then(async (resdata) => {
        if (resdata.data.length === 0) {
          setHasMore(false);
          setCompanyLoader(true);
        } else {
          setCompanyLoader(false);
          setCompanies((prevData) => [...prevData, ...resdata.data]);
          setOffset(offset + resdata.data.length);
        }
      });
    });
  };


  const fetchMoreFavs = () => {

    fetch(`${Key.domain}/company/getFavourites`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        page: favoffset,
        limit: limit,
        uid: sessionStorage.getItem('id'),
      }),
    }).then(async (response) => {
      response.json().then(async (resdata) => {
        if (resdata.data.length === 0) {
          setFavHasMore(false);
          setCompanyLoader(true);
        } else {
          setFavoriteCompanies(resdata.data);
          setFavOffset(favoffset + resdata.data.length);

        }
      });
    });

  }

  const resetToScrollStart = () => {
    // Reset items to the initial state
    setSearchInputValue('');
    setCompanyContacts([]);
    setCompanyJobs([]);
    setcontactsoffset(0);
    setjoboffset(0);
    setContactDetails({});
    setJobDetails({});

    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  };
  const getCompanyDetails = (company_ID) => {
    if (parseInt(companyDetails?.id) !== parseInt(company_ID)) {
      fetch(`${Key.domain}/company/get_Company_Details`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ company_id: company_ID }),
      }).then((response) => {
        response.json().then((resdata) => {
          resetToScrollStart();
          setCompanyId(resdata?.data[0]?.id);
          setCompanyName(resdata?.data[0]?.name);
          setCompanyDetails(resdata?.data[0]);
          getCOmpanyJobs(resdata?.data[0]?.id, 0);
        });
      });
    }
  };

  const fetchCompaniesData = () => {
    fetch(`${Key.domain}/company/get_Companies_List`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        page: offset,
        limit: limit,
        searchBy: 'company',
        title: searchCompanyInputValue,
        user_type_id: sessionStorage.getItem('usertype'),
      }),
    }).then((response) => {
      response.json().then((resdata) => {
        setCompanies(resdata.data);
        setCompanyId(resdata.data[0].id);
        setCompanyName(resdata.data[0].name);
        // getAttorneys(resdata.data[0].id);
        getCompanyDetails(resdata.data[0].id);
        setSelectedCompanyId(resdata.data[0].id);
        setOffset(offset + resdata.data.length);

        // getCOmpanyContacts(resdata.data[0].id);
        // getVisaStrength(resdata.data[0].id);
      });
    });
  };
  useEffect(() => {
    const fetchData = async () => {
      await fetchCompaniesData();
    };

    fetchData();

  }, []);
  useEffect(() => {
    const elements = document.querySelectorAll('.job-description');

    elements.forEach((element) => {
      const childElements = element.querySelectorAll('*');
      childElements.forEach((childElement) => {
        childElement.style.fontSize = '12px';
      });
    });
  }, [jobDetails, recruiterview]);

  const getCOmpanyContacts = (compId, offset, searchQuery = true) => {
    if (
      searchQuery &&
      searchInputValue.length !== '' &&
      searchInputValue !== undefined &&
      searchInputValue.length > 1
    ) {
      // console.log(searchInputValue.length);
    } else {
      if (parseInt(companyContacts?.length) === 0) {
        setContactDetails({});
      }

      if (offset !== undefined && offset !== null && offset !== '') {
        var pageoffset = offset !== undefined && offset !== null && offset !== '' ? offset : contactsoffset;
        setCompanyContacts([]);
        setselectedcontact({});
      } else {
        var pageoffset = offset !== undefined && offset !== null && offset !== '' ? offset : contactsoffset;
      }

      let company_id = compId ? compId : companyDetails?.id;

      if (company_id !== undefined && company_id !== null && company_id !== '' && company_id) {
        // console.log(company_id);
        axios
          .post(`${Key.domain}/company/get_Company_Contacts`, {
            company_id: company_id,
            page: pageoffset,
            state: jobDetails?.statename,
          })
          .then((resdata) => {
            // console.log(pageoffset);

            if (resdata.data.data.length > 0) {
              setcontactshasmore(false);
            } else {
              setCompanyContacts((prevData) => [...prevData, ...resdata.data.data.companyContacts]);
              setcontactsoffset(pageoffset + resdata.data.data.companyContacts.length);
            }

            if (parseInt(pageoffset) === 0) {
              setContactDetails(resdata?.data?.data?.companyContacts?.[0]);
              setselectedcontact(resdata?.data?.data?.companyContacts?.[0]?.ID || 0);
            }
          });
      } else {
        // console.log(company_id);
      }
    }
  };

  const getCOmpanyJobs = (compId, offset) => {
    let company_id = compId ? compId : companyDetails?.id;

    // setShowLoaderJobs(true)
    if (company_id !== undefined && company_id !== null && company_id !== '' && company_id) {
      var joboffsetvalue = offset !== undefined ? offset : joboffset;
      axios
        .post(`${Key.domain}/company/get_company_jobs`, {
          company_id: company_id,
          page: joboffsetvalue,
          title: searchType === 'job' ? searchInput : '',
        })
        .then((resdata) => {
          // setShowLoaderJobs(false)
          if (resdata?.data?.data?.length > 0) {
            setjobshasmore(false);
          } else {
            if (parseInt(joboffsetvalue) === 0) {
              setCompanyJobs(resdata?.data?.data?.companyJobs);
              setTotalJobsCount(resdata?.data?.data?.total_jobs_count)
            } else {
              setCompanyJobs((prevData) => [...prevData, ...resdata?.data?.data?.companyJobs]);
            }
            setjoboffset(joboffsetvalue + resdata?.data?.data?.companyJobs?.length);
          }
          if (parseInt(joboffsetvalue) === 0) {
            getJobDetail(resdata?.data?.data?.companyJobs[0].id);
          }
          // setselectedcontact(resdata.data.data.companyJobs[0].ID);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      // console.log(company_id);
    }
  };

  const getJobDetail = (jobId) => {
    axios
      .post(`${Key.domain}/company/get_company_job_detail`, {
        job_id: jobId,
      })
      .then((resdata) => {
        if (resdata?.data.success === 1) {
          setJobDetailsLoader(false);
          setJobDetails(resdata?.data?.data?.job_detail);
          setselectedJobId(jobId);
          let job_contact_id = resdata?.data?.data?.job_detail?.job_contact_id;
          if (job_contact_id) {
            getContactDetail(resdata?.data?.data?.job_detail?.job_contact_id);
            setShowContacts(false);
          } else {
            setShowContacts(true);
          }
        } else {
          setJobDetailsLoader(true);
        }
      });
  };

  const getContactDetail = (contact) => {
    if (contact && contact.ID) {
      axios
        .post(`${Key.domain}/company/get_contact_detail`, {
          contact_id: contact.ID,
        })
        .then((resdata) => {
          setShowContacts(false);

          if (resdata?.data.success === 1 && resdata?.data?.data?.contact_detail) {
            setContactDetails(resdata?.data?.data?.contact_detail);
            setselectedcontact(resdata?.data?.data?.contact_detail?.ID || 0);

            if (resdata?.data?.data?.contact_detail?.EMP_CONTACT_EMAIL === 'email_not_unlocked@domain.com') {
              viewEmailApollo(contact);
            }
          } else {
            setContactDetails(contact);
            setselectedcontact(contact?.ID || 0);
          }
        });
    }
  };

  const searchCompany = (value) => {
    setOffset(0);
    setSearchCompanyInputValue(value);

    fetch(`${Key.domain}/company/get_Companies_List`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        page: 0,
        limit: limit,
        searchBy: searchType,
        title: searchInput,
        user_type_id: sessionStorage.getItem('usertype'),
      }),
    }).then((response) => {
      response.json().then((resdata) => {
        if (resdata.data.length === 0) {
          setHasMore(false);
          setCompanyLoader(true);
        } else {
          setCompanyLoader(false);
          setCompanies(resdata.data);
          setCompanyId(resdata.data[0].id);
          setCompanyName(resdata.data[0].name);
          // getAttorneys(resdata.data[0].id);
          getCompanyDetails(resdata.data[0].id);
          setSelectedCompanyId(resdata.data[0].id);
          setOffset(0 + resdata.data.length);
        }
      });
    });
  };
  const getContactMailData = (contact) => {
    axios
      .post(
        // 'http://localhost:9992/company/get_contact_mails_data'
        `${Key.domain}/company/get_contact_mails_data`,
        {
          contact_id: contact.ID,
          user_id: sessionStorage.getItem('id'),
        }
      )
      .then((resData) => {
        setContactMailData(resData.data.data);
      });
  };
  const sendMailRecruiter = (contact) => {
    setSendMail(!sendMail);
    setShowMailForm(false);
    getContactMailData(contact);
  };

  const handleSendMail = (contact) => {
    // console.log(recruiterEmail, subject, message);
    if (subject != '' && message != '') {
      try {
        axios
          .post(`${Key.domain}/company/sendMail`, {
            contact_email: contact.EMP_CONTACT_EMAIL,
            subject: subject,
            message: message,
            userId: sessionStorage.getItem('id'),
            contactId: contact.ID,
            activityType: 'email',
          })
          .then((resdata) => {
            // console.log(resdata);
            setShowMailForm(false);
            setSubject('');
            setMessage('');
            // setSendMail(false);
            setShowContactMail(false);
            getContactMailData(contact);
            if (resdata.data.success == 1) {
              // console.log('sent mail');
              var msg = 'Mail sent';
              toast(<ToastMessage message={msg} />);
            }
          })
          .catch((error) => console.error(error));
      } catch (err) {
        console.error(err);
      }
    } else {
      var msg = 'Fields should not empty';
      toast(<ToastMessage message={msg} />);
    }
  };

  console.log(contactDetails);

  const updateEmailVerifyStatus = (category) => {
    axios
      .post(`${Key.domain}/company/update_contact_verify_status`, {
        contact_id: contactDetails?.ID,
        company_id: contactDetails?.COMPANY_ID,
        phone_verified: category === 'Phone' ? 1 : contactDetails?.phone_verified,
        email_verified: category === 'Email' ? 1 : contactDetails?.email_verified,
        contact_email: contactDetails?.EMP_CONTACT_EMAIL,
        contact_name: contactDetails?.EMP_CONTACT_NAME,
        contact_phone: contactDetails?.EMP_CONTACT_PHONE,
      })
      .then((response) => {
        // console.log('ress', response.data.data);
        if (response.data.data.affectedRows > 0) {
          //GetVerificationStatus()
          let contactsoffset = 0;
          // getCOmpanyContacts(contactDetails?.COMPANY_ID, contactsoffset);
          // console.log('contactDetails?.COMPANY_ID', contactDetails?.COMPANY_ID);
          let msg = `${category} Verified Successfully`;
          toast(<ToastMessage message={msg} />);
        } else {
          let msg = 'Something Went Wrong';
          toast(<ToastMessage message={msg} />);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const viewEmailApollo = (contact) => {
    console.log('viewEmailApollo');

    axios
      .post(`${Key.CONTACTS_SERVICE_URL}/contacts/verify_email`, {
        linkedin_url: contact?.EMP_LINKEDIN_URL,
      })
      .then((response) => {
        console.log('ress', response.data.data);
        if (response.data.data.person_email) {
          //GetVerificationStatus()
          const updatedContactDetails = {
            ...contact,
            EMP_CONTACT_EMAIL: response.data.data.person_email,
          };

          setContactDetails(updatedContactDetails);
        } else {
          let msg = 'Email not found';
          toast(<ToastMessage message={msg} />);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSearchContacts = (searchInput, result) => {
    setSearchContactResult(searchInput?.length > 0 && result?.length > 0 ? result?.length : 0);
    setCompanyContacts(searchInput?.length > 0 && result?.length > 0 ? result : []);
    setSearchInputValue(searchInput);
    if (parseInt(searchInput?.length) === 0) {
      getCOmpanyContacts(companyDetails?.id, 0);
    }
  };

  const updateJobContact = (contact) => {
    axios
      .post(`${Key.domain}/company/update_job_contact`, {
        contact_id: contact?.ID,
        job_id: jobDetails?.id,
      })
      .then((response) => {
        if (response.data.data.affectedRows > 0) {
          let msg = `${jobDetails?.title} with ${contact?.EMP_CONTACT_NAME} Updated Successfully`;
          toast(<ToastMessage message={msg} />);
        } else {
          let msg = 'Something Went Wrong';
          toast(<ToastMessage message={msg} />);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleEditContact = () => {
    setShowEditContact(true);
  };
  const handleEditContactClose = (value) => {
    // console.log(value);
    setShowContacts(true);
    setShowEditContact(value);
  };
  const handleAddContactPopupClose = (value) => {
    setShowAddContactPopup(value);
  };
  // console.log('contacts details loader :',companyJobs?.length > 0 && contactDetails )
  return (
    <>
      {searchType === 'contact' ? (
        <Contacts />
      ) : (
        <div>
          <Grid container spacing={1} style={{  }}>
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              className="leftsidegrid"
              style={{
                borderRightColor: '#000',

                padding: '0px',
                // width: '260px',
                position: 'fixed',
                width: 'inherit',
              }}
            >
              <div className="card mt-1">
                <Box sx={{ width: '100%' }}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      textColor="secondary"
                      indicatorColor="secondary"
                      aria-label="secondary tabs example"
                    >
                      <Tab label="Companies" {...a11yProps(0)} />
                      <Tab
                        label={
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginLeft: '6px' }}>Favourites</span>
                            <StarIcon style={{ fontSize: '16px', marginLeft: '6px', marginTop: '2px' }} />
                          </div>
                        }
                        {...a11yProps(1)}
                      />
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={value} index={0}>
                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                      {/* Render companies list */}
                      <div ref={scrollRef}>
                        <InfiniteScroll
                          dataLength={companies?.length}
                          next={fetchMoreData}
                          hasMore={hasMore}
                          //loader={<h4>Loading...</h4>}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>Yay! You have seen it all</b>
                            </p>
                          }
                          height={570}
                          className="infinityscroll"
                          //   className='scroll'
                          style={{ overflowY: 'scroll', overflowX: 'hidden' }}
                          scrollableTarget="scrollableDiv"
                          // refreshFunction={refresh}
                          // pullDownToRefresh
                          pullDownToRefreshThreshold={50}
                        // pullDownToRefreshContent={
                        //   <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
                        // }
                        // releaseToRefreshContent={
                        //   <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
                        // }
                        >
                          {companies.map((company) => (
                            <Card
                              key={company.id}
                              onMouseEnter={() => {
                                setIsHovered(true);
                                setSelectedCompanyId(company.id);
                              }}
                              onMouseLeave={() => setIsHovered(false)}
                              style={{
                                backgroundColor:
                                  selectedCompanyId === company.id ? 'rgba(25, 118, 210, 0.08)' : 'white',
                              }}
                            >
                              <div className="p-2">
                                <div className="row">
                                  <div className="col-2">
                                    <ListItemAvatar>
                                      <Avatar className="companyimg" style={{ backgroundColor: 'rgb(169, 169, 169)' }}>
                                        <HiOutlineBuildingOffice />
                                      </Avatar>
                                    </ListItemAvatar>
                                  </div>
                                  <div
                                    className="col-8 companiestitle"
                                    style={{
                                      color: 'rgb(33 37 41 / 80%)',
                                      fontSize: '12px',
                                      fontWeight: 700,
                                      cursor: 'pointer',
                                      paddingLeft: '22px',
                                      paddingTop: '9px',
                                    }}
                                    onClick={() => {
                                      setCompanyId(company.id);
                                      setCompanyName(company.name);
                                      getCompanyDetails(company.id);
                                      setSelectedCompanyId(company.id);
                                      // setselectedcontact(company.ID);
                                      // getAttorneys(company.id);
                                      // getCompanyContacts(company.id);
                                      // getCompanyJobs(company.id);
                                      // getVisaStrength(company.id);
                                      setrecruiterview(false);
                                      setShowContacts(false);
                                    }}
                                  >
                                    <span title={company?.name}>
                                      {company?.name?.length > 25 ? `${company.name.slice(0, 25)}...` : company?.name}
                                    </span>
                                  </div>
                                  {isHovered && selectedCompanyId === company.id && (
                                    <div className="col-2">
                                      <Tooltip
                                        title={isFavorite(company.id) ? 'Remove from Favorites' : 'Add to Favorites'}
                                      >
                                        {favoriteCompanies?.length > 0 && favoriteCompanies?.some((favCompany) => favCompany?.id === company?.id) ?  (
                                          <StarIcon
                                            style={{ color: 'gold', fontSize: '20px', cursor: 'pointer' }}
                                            onClick={() => removeFromFavorites(company.id)}
                                          />
                                        ) : (
                                          <StarBorder
                                            style={{ color: 'gold', fontSize: '20px', cursor: 'pointer' }}
                                            onClick={() => addToFavorites(company.id)}
                                          />
                                        )}
                                      </Tooltip>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Card>
                          ))}
                        </InfiniteScroll>
                      </div>
                    </List>
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={1}>
                    {/* Render favorite companies list */}
                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                      <InfiniteScroll
                        dataLength={favoriteCompanies?.length}
                        next={fetchMoreFavs}
                        hasMore={favHasMore}
                        endMessage={
                          <p style={{ textAlign: 'center' }}>
                            <b>Yay! You have seen it all</b>
                          </p>
                        }
                        height={570}
                        className="infinityscroll"
                        style={{ overflowY: 'scroll', overflowX: 'hidden' }}
                        scrollableTarget="scrollableDiv"
                        pullDownToRefreshThreshold={50}
                      >
                        {favoriteCompanies.map((company) => (
                          <Card key={company.id}>
                            {/* Render your favorite company card here */}
                            <div className="p-2">
                              <div className="row">
                                <div className="col-2">
                                  <ListItemAvatar>
                                    <Avatar className="companyimg" style={{ backgroundColor: 'rgb(169, 169, 169)' }}>
                                      <HiOutlineBuildingOffice />
                                    </Avatar>
                                  </ListItemAvatar>
                                </div>
                                <div
                                  className="col-8 companiestitle"
                                  style={{
                                    color: 'rgb(33 37 41 / 80%)',
                                    fontSize: '12px',
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                    paddingLeft: '22px',
                                    paddingTop: '9px',
                                  }}
                                  onClick={() => {
                                    setCompanyId(company.id);
                                    setCompanyName(company.name);
                                    getCompanyDetails(company.id);
                                    setSelectedCompanyId(company.id);
                                    // setselectedcontact(company.ID);
                                    // getAttorneys(company.id);
                                    // getCompanyContacts(company.id);
                                    // getCompanyJobs(company.id);
                                    // getVisaStrength(company.id);
                                    setrecruiterview(false);
                                    setShowContacts(false);
                                  }}
                                >
                                  <span title={company?.name}>
                                    {company?.name?.length > 25 ? `${company.name.slice(0, 25)}...` : company?.name}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Card>
                        ))}
                      </InfiniteScroll>
                    </List>
                  </CustomTabPanel>
                </Box>
              </div>
            </Grid>
            <Grid
              item
              xs={10}
              md={10}
              sm={10}
              className="rightsidegrid"
              style={{
                marginTop: '-6px',
                marginLeft: '257px',
                position: 'fixed',
              }}
            >
              {/* jobs view */}
              <Grid container spacing={1}>
                <Grid item md={3}>
                  {/* <CompanyJobs handleClick={handleClick}/> */}
                  <CompanyJobs
                    companyJobs={companyJobs}
                    getCOmpanyJobs={getCOmpanyJobs}
                    jobshasmore={jobshasmore}
                    selectedJobId={selectedJobId}
                    getJobDetail={getJobDetail}
                    jobsCount={totalJobsCount}
                  />
                </Grid>
                {/* job detail view */}
                <Grid item md={6}>
                  <CompanyJobDetail jobDetails={jobDetails} showContact={() => setShowContacts(!showContacts)} />
                </Grid>
                {companyJobs?.length > 0 && contactDetails ? (
                  <>
                    {/* contacts view right side  */}
                    {showContacts ? (
                      <Grid item md={3}>
                        {/* contacts list */}

                        <Card>
                          <div className="row">
                            <div className="col-8">
                              <div
                                variant="text"
                                style={{ fontWeight: '500', height: '45px', textAlign: 'left', padding: '8px' }}
                              >
                                Contacts{' '}
                                {/* <StarIcon
                              style={{
                                fontSize: 'medium',
                                color: 'rgb(0 0 0 / 70%)',
                                marginLeft: '8px',
                                marginTop: '-2px',
                              }}
                            /> */}
                                <Tooltip title="Refresh">
                                  <IconButton>
                                    <HiOutlineRefresh
                                      onClick={() => getCOmpanyContacts(companyDetails?.id, 0)}
                                      fontSize={'18px'}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </div>
                            <div className="col-2" style={{ paddingTop: '8px', paddingLeft: '17px' }}>
                              {parseInt(sessionStorage.getItem('usertype'), 10) === 8 ? (
                                <div className=" d-flex align-items-center justify-content-start">
                                  <Tooltip title="Add Contact" arrow>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={() => setShowAddContactPopup(true)}
                                      style={{ marginTop: '-6px', marginLeft: '-9px' }}
                                    >
                                      <CiSquarePlus style={{ fontSize: '25px' }} />
                                    </Button>
                                  </Tooltip>
                                </div>
                              ) : null}
                            </div>
                            <div className="col-2" style={{ paddingTop: '2px', paddingLeft: '0px' }}>
                              {/* <span>
                        <input type='text' 
                      style={{border:"1px solid lightgrey",borderRadius:"4px",marginTop:"7px"}}
                      // onChange={(e) => searchContactName(e.target.value)}
                      /></span> */}
                              <Search
                                companyId={companyId}
                                handleSearchContacts={handleSearchContacts}
                                searchInputValue={searchInputValue}
                                jobDetails={jobDetails}
                              />
                            </div>
                          </div>
                        </Card>

                        <Card>
                          {/* <h3 style={{ fontSize: '15px' }}>Compnay contact</h3> */}
                          <div ref={scrollRef}>
                            <InfiniteScroll
                              dataLength={companyContacts?.length}
                              next={() => getCOmpanyContacts()}
                              hasMore={contactshasmore}
                              height={570}
                              className="infinityscroll"
                              //   className='scroll'
                              style={{ overflowY: 'scroll', overflowX: 'hidden' }}
                              scrollableTarget="scrollableDiv"
                              // refreshFunction={refresh}
                              // pullDownToRefresh
                              pullDownToRefreshThreshold={50}
                            >
                              <div className="row">
                                {companyContacts?.length > 0 ? (
                                  companyContacts.map((contact) => (
                                    <div
                                      style={{ cursor: 'pointer' }}
                                    // onClick={() => {
                                    //   setContactDetails(contact);
                                    //   setselectedcontact(contact.ID);
                                    //   setShowContacts(false);
                                    //   setSendMail(false)
                                    //   setContactMailData([])
                                    // }}
                                    >
                                      <List
                                        className="card1"
                                        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                                        style={{ paddingBottom: '0px', marginBottom: '-6px' }}
                                      >
                                        <ListItem
                                          alignItems="flex-start"
                                          style={{
                                            paddingBottom: '5px',
                                            paddingTop: '5px',
                                            backgroundColor:
                                              selectedcontact === contact.ID ? 'rgba(25, 118, 210, 0.08)' : 'white',
                                          }}
                                        >
                                          <ListItemAvatar>
                                            <Avatar
                                              // alt="yser Profile"
                                              src={
                                                contact.EMP_PHOTO_URL != null
                                                  ? contact.EMP_PHOTO_URL
                                                  : 'https://static.licdn.com/aero-v1/sc/h/244xhbkr7g40x6bsu4gi6q4ry'
                                              }
                                            />
                                          </ListItemAvatar>
                                          <ListItemText
                                            onClick={() => {
                                              getContactDetail(contact);
                                              setselectedcontact(contact.ID);
                                              setSendMail(false);
                                              setContactMailData([]);
                                            }}
                                            primary={
                                              <div>
                                                <Typography
                                                  variant="body2"
                                                  style={{ fontSize: '12px', fontWeight: '700' }}
                                                >
                                                  {contact.EMP_CONTACT_NAME}

                                                  {parseInt(sessionStorage.getItem('usertype'), 10) === 8 ? (
                                                    <div>
                                                      <Tooltip title="Edit" arrow placement="top">
                                                        <span
                                                          style={{ float: 'right' }}
                                                          onClick={() => handleEditContact()}
                                                        >
                                                          <IoPricetagOutline
                                                            className="edit-icon"
                                                            style={{ fontSize: '15px', color: 'rgb(0 0 0 / 60%)' }}
                                                          />
                                                        </span>
                                                      </Tooltip>
                                                    </div>
                                                  ) : (
                                                    ''
                                                  )}
                                                </Typography>
                                              </div>
                                            }
                                            secondary={
                                              <div>
                                                <Typography
                                                  sx={{ display: 'inline' }}
                                                  component="span"
                                                  variant="body2"
                                                  color="text.primary"
                                                  style={{ fontSize: '12px' }}
                                                >
                                                  {contact.EMP_DECL_TITLE &&
                                                    contact.EMP_DECL_TITLE.slice(0, 50) + '...'}
                                                </Typography>
                                              </div>
                                            }
                                          />
                                        </ListItem>
                                      </List>

                                      {/* <hr /> */}
                                    </div>
                                  ))
                                ) : (
                                  <div
                                    style={{
                                      textAlign: 'center',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      height: '557px',
                                    }}
                                  >
                                    Data not found
                                  </div>
                                )}
                              </div>
                            </InfiniteScroll>
                          </div>
                        </Card>
                      </Grid>
                    ) : (
                      <Grid item md={3}>
                        {/* contacts detail view */}

                        <Card>
                          <p
                            style={{ height: '0px' }}
                            onClick={() => {
                              setShowContacts(true);
                            }}
                          >
                            <Tooltip title="Back To Contacts">
                              <IconButton>
                                <IoIosArrowRoundBack fontSize={'25px'} />
                              </IconButton>
                            </Tooltip>
                          </p>
                          <div className="row">
                            <div style={{ textAlign: 'center' }}>
                              {/* <div style={{ float: 'right' }} onClick={() => updateJobContact(contactDetails)}>
                            <Tooltip title="Attach Contact">
                              <IconButton>
                                <PermContactCalendarOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </div> */}
                              <center>
                                <Avatar
                                  style={{
                                    // display: 'block', // Make the image a block element
                                    // margin: 'auto', // Center the image horizontally
                                    // You might also want to add styles for height and width if needed
                                    height: '50px',
                                    width: '50px',
                                    top: '8px',
                                    marginBottom: '14px',
                                    // marginLeft: '33px',
                                  }}
                                  src={contactDetails && contactDetails?.EMP_PHOTO_URL}
                                >
                                  <AccountCircleRoundedIcon />
                                </Avatar>
                              </center>
                              <h3 style={{ marginTop: '5px', fontSize: '15px' }}>
                                {contactDetails && contactDetails?.EMP_CONTACT_NAME}
                              </h3>
                              <p style={{ fontSize: '12px', marginBottom: '2px' }}>
                                Location&nbsp;:&nbsp;
                                {contactDetails.EMP_CONTACT_CITY && contactDetails.EMP_CONTACT_STATE_PROVINCE
                                  ? `${contactDetails.EMP_CONTACT_CITY}, ${contactDetails.EMP_CONTACT_STATE_PROVINCE}`
                                  : 'N/A'}
                              </p>

                              {contactDetails &&
                                contactDetails?.EMP_LINKEDIN_URL !== 'null' &&
                                contactDetails?.EMP_LINKEDIN_URL && (
                                  <p>
                                    <a
                                      href={contactDetails.EMP_LINKEDIN_URL}
                                      target="_blank"
                                      style={{
                                        textDecoration: 'none',
                                        cursor: 'pointer',
                                        color: '#000',
                                        fontSize: '12px',
                                      }}
                                    >
                                      <TbBrandLinkedin color="#212529" fontSize={'21px'} /> Linkedin Profile
                                    </a>
                                  </p>
                                )}

                              {contactDetails && (
                                <p style={{ fontSize: '12px', marginBottom: '10px' }}>
                                  {contactDetails?.EMP_CONTACT_EMAIL !== 'email_not_unlocked@domain.com' &&
                                    contactDetails?.EMP_CONTACT_EMAIL !== 'null' &&
                                    contactDetails?.EMP_CONTACT_EMAIL ? (
                                    contactDetails?.EMP_CONTACT_EMAIL
                                  ) : contactDetails?.EMP_CONTACT_EMAIL === 'email_not_unlocked@domain.com' ? (
                                    <span onClick={() => viewEmailApollo(contactDetails)}>View Email</span>
                                  ) : (
                                    ''
                                  )}

                                  {contactDetails?.EMP_CONTACT_EMAIL !== 'null' &&
                                    contactDetails?.EMP_CONTACT_EMAIL &&
                                    contactDetails?.EMP_CONTACT_EMAIL !== undefined && (
                                      <span
                                        variant="outlined"
                                        onClick={() => updateEmailVerifyStatus('Email')}
                                        style={{
                                          ...textStyle,
                                          backgroundColor: '#FFF',
                                          borderRadius: '14px',
                                          color:
                                            contactDetails?.email_verified === 1
                                              ? 'rgb(102, 102, 102)'
                                              : 'rgb(102, 102, 102)',
                                          cursor: 'pointer',
                                          border: contactDetails?.email_verified === 1 ? 'none' : '1px solid lightgrey',
                                          padding: '7px',
                                          fontSize: '10px',
                                          fontWeight: '500',
                                        }}
                                      >
                                        {contactDetails?.email_verified === 1 ? (
                                          <span
                                            style={{
                                              // border: '1px solid #FFF',
                                              cursor: 'pointer',
                                              backgroundColor: '#406882',
                                              borderRadius: '12px',
                                              color: '#FFF',
                                              fontSize: '10px',
                                              fontWeight: '500',
                                              padding: '5px 10px',
                                            }}
                                          >
                                            Verified{' '}
                                            <CheckCircleOutline
                                              style={{ fontSize: '16px', verticalAlign: 'middle' }}
                                            />
                                          </span>
                                        ) : (
                                          <span>Verify</span>
                                        )}
                                      </span>
                                    )}
                                </p>
                              )}

                              {contactDetails &&
                                contactDetails?.EMP_CONTACT_PHONE !== 'null' &&
                                contactDetails?.EMP_CONTACT_PHONE && (
                                  <p style={{ fontSize: '12px' }}>
                                    {contactDetails?.EMP_CONTACT_PHONE !== undefined &&
                                      contactDetails?.EMP_CONTACT_PHONE !== null
                                      ? contactDetails?.EMP_CONTACT_PHONE
                                      : ''}
                                    <span
                                      onClick={() => updateEmailVerifyStatus('Phone')}
                                      style={{
                                        ...textStyle1,
                                        fontSize: '10px',
                                        color: contactDetails.phone_verified === 1 ? '#FFF' : 'rgb(102 102 102)',
                                        fontWeight: '500',
                                        backgroundColor:
                                          contactDetails.phone_verified === 1 ? '#406882' : 'transparent',
                                        border: contactDetails.phone_verified === 1 ? 'none' : '1px solid lightgrey',
                                        cursor: 'pointer',
                                        padding: '5px 10px', // Adjust padding as needed
                                        borderRadius: contactDetails.phone_verified === 1 ? '14px' : '14px', // Set border radius conditionally
                                      }}
                                    >
                                      {contactDetails.phone_verified === 1 ? (
                                        <>
                                          Verified{' '}
                                          <CheckCircleOutline
                                            style={{ fontSize: '16px', verticalAlign: 'middle' }}
                                          />
                                        </>
                                      ) : (
                                        'Verify'
                                      )}
                                    </span>
                                  </p>
                                )}

                              <div
                                style={{
                                  marginLeft: '12px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginRight: '20px',
                                  }}
                                  onClick={() => handleclicknotes('call')}
                                >
                                  <img src={Call} width={'32px'} />
                                  <p style={{ fontSize: '13px' }}>Call</p>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginRight: '20px',
                                  }}
                                  onClick={() => handleclicknotes('text')}
                                >
                                  <img src={Chat} width={'32px'} />
                                  <p style={{ fontSize: '13px' }}>Text</p>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginRight: '20px',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => handleclicknotes('email')}
                                >
                                  <img src={Email} width={'32px'} onClick={() => sendMailRecruiter(contactDetails)} />
                                  <p style={{ fontSize: '13px' }}>Email</p>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginRight: '20px',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => updateJobContact(contactDetails)}
                                >
                                  <img src={Tag} width={'32px'} />
                                  <p style={{ fontSize: '13px' }}>Tag Job</p>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginRight: '20px',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => handleclicknotes('note')}
                                >
                                  <img src={Note} width={'32px'} />
                                  <p style={{ fontSize: '13px' }}>Notes</p>
                                </div>
                                {showEditContact ? (
                                  <UpdateCompanyContact
                                    contactDetails={contactDetails}
                                    handleEditContactClose={handleEditContactClose}
                                    getCOmpanyContacts={getCOmpanyContacts}
                                  />
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div>
                              {sendMail ? (
                                !showMailForm ? (
                                  <Container style={{ padding: '0px' }}>
                                    <ul style={{ paddingLeft: '10px' }}>
                                      <Card style={{ padding: '5px', height: '150px', overflow: 'auto' }}>
                                        <Card.Title style={{ fontSize: '16px' }}>Mails Log</Card.Title>
                                        {contactMailData.length > 0 ? (
                                          contactMailData.map((item) => (
                                            <li style={{ marginLeft: '4px', listStyleType: 'none' }}>
                                              <Card style={{ padding: '5px', marginBottom: '5px' }}>
                                                <p style={{ fontSize: '12px', marginBottom: '4px' }}>
                                                  <span
                                                    style={{
                                                      float: 'left',
                                                      fontSize: '12px',
                                                      fontWeight: '600',
                                                      marginRight: '2px',
                                                    }}
                                                  >
                                                    Subject :
                                                  </span>
                                                  {item.subject !== '' && item.subject !== null
                                                    ? `${item.subject[0].toUpperCase() + item.subject.slice(1, 20)}`
                                                    : 'N/A'}
                                                  <span style={{ float: 'right', fontSize: '12px' }}>
                                                    {moment(item.created).fromNow()}
                                                  </span>
                                                </p>
                                                <p style={{ fontSize: '12px', marginBottom: '4px' }}>
                                                  <span
                                                    style={{
                                                      float: 'left',
                                                      fontSize: '12px',
                                                      fontWeight: '600',
                                                      marginRight: '2px',
                                                    }}
                                                  >
                                                    Message :
                                                  </span>
                                                  <span
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      setShowContactMessage(true);
                                                      setContactMailMessage(item.message);
                                                      setContactMailSubject(item.subject);
                                                    }}
                                                  >
                                                    {item?.message !== '' &&
                                                      item?.message.length > 0 &&
                                                      item?.message?.length > 20
                                                      ? `${item.message[0].toUpperCase() + item.message.slice(1, 20)
                                                      }...`
                                                      : item.message[0]?.toUpperCase() + item.message.slice(1)}
                                                  </span>
                                                </p>
                                                {/* <span style={{ fontSize: '12px' }}>{item.message[0].toUpperCase()+item.message.slice(1, 20)}</span> */}
                                              </Card>
                                            </li>
                                          ))
                                        ) : (
                                          <p style={{ fontSize: '12px', textAlign: 'center', margin: 'auto' }}>
                                            No Mails Log
                                          </p>
                                        )}
                                      </Card>
                                    </ul>

                                    <Button
                                      // variant="secondary"
                                      style={{
                                        fontSize: '12px',
                                        marginTop: '10px',
                                        marginBottom: '10px',
                                        marginRight: '12px',
                                        backgroundColor: '#fff',
                                        color: '#000',
                                        border: '1px solid gray',
                                        float: 'right',
                                      }}
                                      onClick={() => {
                                        setShowMailForm(true);
                                      }}
                                    >
                                      Send Mail
                                    </Button>
                                  </Container>
                                ) : (
                                  <>
                                    <Container>
                                      <Form>
                                        <Form.Group>
                                          <Form.Label style={{ fontSize: '12px' }}>Subject</Form.Label>
                                          <Form.Control
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter Subject"
                                            name="subject"
                                            onChange={(e) => setSubject(e.target.value)}
                                            value={subject}
                                          />
                                          <Form.Label style={{ fontSize: '12px' }}>Message</Form.Label>
                                          <textarea
                                            class="form-control"
                                            placeholder="Enter Message"
                                            id="exampleFormControlTextarea1"
                                            rows="3"
                                            onChange={(e) => setMessage(e.target.value)}
                                            value={message}
                                          ></textarea>
                                        </Form.Group>

                                        <Button
                                          // variant="secondary"
                                          style={{
                                            fontSize: '12px',
                                            float: 'right',
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                            marginLeft: '12px',
                                            backgroundColor: '#fff',
                                            color: '#000',
                                            border: '1px solid gray',
                                          }}
                                          onClick={(e) => {
                                            handleSendMail(contactDetails);
                                          }}
                                        >
                                          Send
                                        </Button>
                                      </Form>
                                    </Container>
                                  </>
                                )
                              ) : (
                                <ContactActivity viewComponent={contactActivityView} contactDetails={contactDetails} />
                              )}
                            </div>
                          </div>
                        </Card>
                      </Grid>
                    )}
                  </>
                ) : (
                  <Grid item md={3}>
                    {/* contacts list */}

                    <Card>
                      <div className="row">
                        <div className="col-8">
                          <div
                            variant="text"
                            style={{ fontWeight: '500', height: '45px', textAlign: 'left', padding: '8px' }}
                          >
                            Contacts{' '}
                            {/* <StarIcon
                          style={{
                            fontSize: 'medium',
                            color: 'rgb(0 0 0 / 70%)',
                            marginLeft: '8px',
                            marginTop: '-2px',
                          }}
                        /> */}
                          </div>
                        </div>
                        <div className="col-2" style={{ paddingTop: '8px', paddingLeft: '17px' }}>
                          {parseInt(sessionStorage.getItem('usertype'), 10) === 8 ? (
                            <div className=" d-flex align-items-center justify-content-start">
                              <Tooltip title="Add Contact1" arrow>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => setShowAddContactPopup(true)}
                                  style={{ marginTop: '-6px', marginLeft: '-9px' }}
                                >
                                  <CiSquarePlus style={{ fontSize: '25px' }} />
                                </Button>
                              </Tooltip>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </Card>

                    <Card>
                      {/* <h3 style={{ fontSize: '15px' }}>Compnay contact</h3> */}

                      <div className="row">
                        <div
                          style={{
                            textAlign: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '557px',
                          }}
                        >
                          Data not found
                        </div>
                      </div>
                    </Card>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Modal
            size="md"
            show={showContactMessage}
            onHide={() => setShowContactMessage(false)}
            centered
            // style={{ marginLeft: "8%", marginTop:"100px"}}
            style={{ paddingTop: '80px' }}
          >
            <Modal.Header closeButton></Modal.Header>

            <Modal.Body>
              <div>
                <p style={{ fontSize: '14px' }}>
                  <span style={{ fontWeight: '600', marginRight: '4px' }}>Subject :</span>
                  {contactMailSubject !== '' && contactMailSubject !== null && contactMailSubject !== undefined
                    ? contactMailSubject[0].toUpperCase() + contactMailSubject.slice(1)
                    : 'N/A'}
                </p>

                <p style={{ fontSize: '14px' }}>
                  <span style={{ fontWeight: '600', marginRight: '4px' }}>Message :</span>
                  {contactMailMessage !== '' && contactMailMessage !== null && contactMailMessage !== undefined
                    ? contactMailMessage[0].toUpperCase() + contactMailMessage.slice(1)
                    : 'N/A'}
                </p>
              </div>
            </Modal.Body>
          </Modal>

          {showAddContactPopup ? (
            <AddCompanyContact
              showAddContactPopup={showAddContactPopup}
              companyDetails={companyDetails}
              getCOmpanyContacts={getCOmpanyContacts}
              handleAddContactPopupClose={handleAddContactPopupClose}
            />
          ) : (
            ''
          )}
        </div>
      )}
    </>
  );
}

export default Companyinfo;
